import React from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'

import Properties from '../components/Properties'
import Residents from '../components/Residents'
import Details from '../components/Details'

import PropertyRoutes from './PropertyRoutes'

const GuestRoutes = ({ location }) => {
  return (
    <Switch location={location}>
      <Route key="properties" exact path="/" component={Properties} />,
      <Route key="properties" exact path="/properties" component={Properties} />,
      <Route key="property" path="/properties/:id" component={PropertyRoutes} />,
      <Route key="residents" exact path="/residents" component={Residents} />,
      <Route key="detail" path="/:category(residents)/:id" exact component={Details} />
    </Switch>

  )
}

export default withRouter(GuestRoutes)



// WEBPACK FOOTER //
// ./src/routes/GuestRoutes.jsx